/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/currency';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "rstonboard": {
        "nested": {
          "CloseOfDayReportSettings": {
            "fields": {
              "openTicketsMustBeClosed": {
                "type": "bool",
                "id": 1,
                "rule": "optional",
                "options": {
                  "default": true
                }
              },
              "tipsMustBeSettledManually": {
                "type": "bool",
                "id": 2,
                "rule": "optional",
                "options": {
                  "default": true
                }
              },
              "cashDrawersMustBeClosed": {
                "type": "bool",
                "id": 3,
                "rule": "optional",
                "options": {
                  "default": true
                }
              },
              "clockedInEmployeesMustBeClockedOut": {
                "type": "bool",
                "id": 4,
                "rule": "optional",
                "options": {
                  "default": true
                }
              },
              "showCategorySales": {
                "type": "bool",
                "id": 5,
                "rule": "optional",
                "options": {
                  "default": true
                }
              },
              "showIndividualItemSales": {
                "type": "bool",
                "id": 6,
                "rule": "optional",
                "options": {
                  "default": true
                }
              },
              "showDiscountsSections": {
                "type": "bool",
                "id": 7,
                "rule": "optional",
                "options": {
                  "default": true
                }
              }
            }
          },
          "EmployeeShiftReportSettings": {
            "fields": {
              "openTicketsMustBeClosed": {
                "type": "bool",
                "id": 1,
                "rule": "optional",
                "options": {
                  "default": true
                }
              },
              "tipsMustBeSettledManually": {
                "type": "bool",
                "id": 2,
                "rule": "optional",
                "options": {
                  "default": true
                }
              },
              "autoGratuityPaidOutAsCashTips": {
                "type": "bool",
                "id": 3,
                "rule": "optional",
                "options": {
                  "default": true
                }
              },
              "showCategorySales": {
                "type": "bool",
                "id": 4,
                "rule": "optional",
                "options": {
                  "default": true
                }
              },
              "showIndividualItemSales": {
                "type": "bool",
                "id": 5,
                "rule": "optional",
                "options": {
                  "default": true
                }
              },
              "showDiscountsSections": {
                "type": "bool",
                "id": 6,
                "rule": "optional",
                "options": {
                  "default": true
                }
              },
              "showCashOwed": {
                "type": "bool",
                "id": 8,
                "rule": "optional",
                "options": {
                  "default": true
                }
              }
            }
          },
          "MenuBehaviorSettings": {
            "fields": {
              "behaviorAfterAddingItem": {
                "type": ".squareup.rstonboard.MenuBehaviorSettings.BehaviorAfterAddingItem",
                "id": 1,
                "rule": "optional",
                "options": {
                  "default": "RETURN_TO_HOME_SCREEN"
                }
              }
            },
            "nested": {
              "BehaviorAfterAddingItem": {
                "values": {
                  "DO_NOT_USE": 0,
                  "RETURN_TO_HOME_SCREEN": 1,
                  "REMAIN_ON_CURRENT_SCREEN": 2
                }
              }
            }
          },
          "ReceiptSettings": {
            "fields": {
              "showFreeModifiers": {
                "type": "bool",
                "id": 1,
                "rule": "optional",
                "options": {
                  "default": true
                }
              },
              "combineLikeItems": {
                "type": "bool",
                "id": 2,
                "rule": "optional",
                "options": {
                  "default": false
                }
              }
            }
          },
          "AutoGratuitySettings": {
            "fields": {
              "autoGratuityEnabled": {
                "type": "bool",
                "id": 1,
                "rule": "optional",
                "options": {
                  "default": false
                }
              }
            }
          },
          "SalesAttributionSettings": {
            "fields": {
              "ticketOwnerPreference": {
                "type": ".squareup.rstonboard.SalesAttributionSettings.TicketOwnerPreference",
                "id": 1,
                "rule": "optional",
                "options": {
                  "default": "CREATOR_EMPLOYEE"
                }
              }
            },
            "nested": {
              "TicketOwnerPreference": {
                "values": {
                  "DO_NOT_USE": 0,
                  "CREATOR_EMPLOYEE": 1,
                  "CLOSING_EMPLOYEE": 2
                }
              }
            }
          },
          "ReopenSettings": {
            "fields": {
              "canReopenChecks": {
                "type": "bool",
                "id": 1,
                "rule": "optional",
                "options": {
                  "default": false
                }
              }
            }
          },
          "CourseSettings": {
            "fields": {
              "courseNames": {
                "type": "string",
                "id": 1,
                "rule": "repeated"
              },
              "hasCourseNames": {
                "type": "bool",
                "id": 2,
                "rule": "optional"
              },
              "printingCoursingTrueHoldEnabled": {
                "type": "bool",
                "id": 3,
                "rule": "optional",
                "options": {
                  "default": false
                }
              }
            }
          },
          "PreAuthSettings": {
            "fields": {
              "isPreAuthEnabled": {
                "type": "bool",
                "id": 1,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "preAuthMin": {
                "type": ".squareup.common.Money",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "ReservationSettings": {
            "fields": {
              "firstTableTouch": {
                "type": ".squareup.rstonboard.ReservationSettings.FirstTableTouch",
                "id": 1,
                "rule": "optional",
                "options": {
                  "default": "FIRST_TABLE_TOUCH_UNUSED"
                }
              }
            },
            "nested": {
              "FirstTableTouch": {
                "values": {
                  "FIRST_TABLE_TOUCH_UNUSED": 0,
                  "FIRST_TABLE_TOUCH_ON": 1,
                  "FIRST_TABLE_TOUCH_OFF": 2
                }
              }
            }
          },
          "ServiceSettings": {
            "fields": {
              "closeOfDayReportSettings": {
                "type": ".squareup.rstonboard.CloseOfDayReportSettings",
                "id": 1,
                "rule": "optional"
              },
              "employeeShiftReportSettings": {
                "type": ".squareup.rstonboard.EmployeeShiftReportSettings",
                "id": 2,
                "rule": "optional"
              },
              "menuBehaviorSettings": {
                "type": ".squareup.rstonboard.MenuBehaviorSettings",
                "id": 3,
                "rule": "optional"
              },
              "printedReceiptSettings": {
                "type": ".squareup.rstonboard.ReceiptSettings",
                "id": 4,
                "rule": "optional"
              },
              "autoGratuitySettings": {
                "type": ".squareup.rstonboard.AutoGratuitySettings",
                "id": 5,
                "rule": "optional"
              },
              "salesAttributionSettings": {
                "type": ".squareup.rstonboard.SalesAttributionSettings",
                "id": 6,
                "rule": "optional"
              },
              "reopenSettings": {
                "type": ".squareup.rstonboard.ReopenSettings",
                "id": 7,
                "rule": "optional"
              },
              "courseSettings": {
                "type": ".squareup.rstonboard.CourseSettings",
                "id": 8,
                "rule": "optional"
              },
              "preAuthSettings": {
                "type": ".squareup.rstonboard.PreAuthSettings",
                "id": 9,
                "rule": "optional"
              },
              "reservationSettings": {
                "type": ".squareup.rstonboard.ReservationSettings",
                "id": 10,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.rstonboard?.nested?.CloseOfDayReportSettings && !$root.nested?.squareup?.nested?.rstonboard?.nested?.EmployeeShiftReportSettings && !$root.nested?.squareup?.nested?.rstonboard?.nested?.MenuBehaviorSettings && !$root.nested?.squareup?.nested?.rstonboard?.nested?.MenuBehaviorSettings?.nested?.BehaviorAfterAddingItem && !$root.nested?.squareup?.nested?.rstonboard?.nested?.ReceiptSettings && !$root.nested?.squareup?.nested?.rstonboard?.nested?.AutoGratuitySettings && !$root.nested?.squareup?.nested?.rstonboard?.nested?.SalesAttributionSettings && !$root.nested?.squareup?.nested?.rstonboard?.nested?.SalesAttributionSettings?.nested?.TicketOwnerPreference && !$root.nested?.squareup?.nested?.rstonboard?.nested?.ReopenSettings && !$root.nested?.squareup?.nested?.rstonboard?.nested?.CourseSettings && !$root.nested?.squareup?.nested?.rstonboard?.nested?.PreAuthSettings && !$root.nested?.squareup?.nested?.rstonboard?.nested?.ReservationSettings && !$root.nested?.squareup?.nested?.rstonboard?.nested?.ReservationSettings?.nested?.FirstTableTouch && !$root.nested?.squareup?.nested?.rstonboard?.nested?.ServiceSettings) {
  $root.addJSON(jsonData);
}

/**
 * Service Settings for Food & Beverage
 *
 * This proto defines configuration settings for RST merchants that control
 * various aspects of restaurants operations including:
 * - Reporting requirements and display options
 * - Menu and receipt behavior
 * - Payment features (auto-gratuity, pre-auth)
 * - Employee attribution and workflow settings
 * Service Settings regarding close of day reports (the reports run by a manager at the end of the day.)
 *
 * SOURCE CloseOfDayReportSettings @ squareup/rstonboard/service_settings/service_settings.proto at 20:1
 */
export const CloseOfDayReportSettings = $root.lookupType('squareup.rstonboard.CloseOfDayReportSettings');
fixType(CloseOfDayReportSettings);
Builder.createAndAttachToType(CloseOfDayReportSettings);
/**
 * Service Settings regarding employee shift reports (the reports run by an employee at the end of their shift.)
 *
 * SOURCE EmployeeShiftReportSettings @ squareup/rstonboard/service_settings/service_settings.proto at 45:1
 */
export const EmployeeShiftReportSettings = $root.lookupType('squareup.rstonboard.EmployeeShiftReportSettings');
fixType(EmployeeShiftReportSettings);
Builder.createAndAttachToType(EmployeeShiftReportSettings);
/**
 * Service Settings regarding menu behavior for RST merchants
 *
 * SOURCE MenuBehaviorSettings @ squareup/rstonboard/service_settings/service_settings.proto at 70:1
 */
export const MenuBehaviorSettings = $root.lookupType('squareup.rstonboard.MenuBehaviorSettings');
fixType(MenuBehaviorSettings);
Builder.createAndAttachToType(MenuBehaviorSettings);
/**
 * SOURCE BehaviorAfterAddingItem @ squareup/rstonboard/service_settings/service_settings.proto at 71:3
 */
MenuBehaviorSettings.BehaviorAfterAddingItem = $root.lookupEnum('squareup.rstonboard.MenuBehaviorSettings.BehaviorAfterAddingItem').values;
/**
 * Service Settings regarding receipt behavior
 *
 * SOURCE ReceiptSettings @ squareup/rstonboard/service_settings/service_settings.proto at 83:1
 */
export const ReceiptSettings = $root.lookupType('squareup.rstonboard.ReceiptSettings');
fixType(ReceiptSettings);
Builder.createAndAttachToType(ReceiptSettings);
/**
 * Service Settings for auto-gratuity
 *
 * SOURCE AutoGratuitySettings @ squareup/rstonboard/service_settings/service_settings.proto at 92:1
 */
export const AutoGratuitySettings = $root.lookupType('squareup.rstonboard.AutoGratuitySettings');
fixType(AutoGratuitySettings);
Builder.createAndAttachToType(AutoGratuitySettings);
/**
 * Service Settings regarding sales attribution
 *
 * SOURCE SalesAttributionSettings @ squareup/rstonboard/service_settings/service_settings.proto at 98:1
 */
export const SalesAttributionSettings = $root.lookupType('squareup.rstonboard.SalesAttributionSettings');
fixType(SalesAttributionSettings);
Builder.createAndAttachToType(SalesAttributionSettings);
/**
 * SOURCE TicketOwnerPreference @ squareup/rstonboard/service_settings/service_settings.proto at 99:3
 */
SalesAttributionSettings.TicketOwnerPreference = $root.lookupEnum('squareup.rstonboard.SalesAttributionSettings.TicketOwnerPreference').values;
/**
 * Service Settings for reopening and updating closed checks
 * Design: https://docs.google.com/document/d/1BXA9e2B9FXDj2iotZRrMRVmE1VQ6NHDl9-zZKn_CwM8/edit
 *
 * SOURCE ReopenSettings @ squareup/rstonboard/service_settings/service_settings.proto at 112:1
 */
export const ReopenSettings = $root.lookupType('squareup.rstonboard.ReopenSettings');
fixType(ReopenSettings);
Builder.createAndAttachToType(ReopenSettings);
/**
 * Service Settings regarding coursing
 *
 * SOURCE CourseSettings @ squareup/rstonboard/service_settings/service_settings.proto at 117:1
 */
export const CourseSettings = $root.lookupType('squareup.rstonboard.CourseSettings');
fixType(CourseSettings);
Builder.createAndAttachToType(CourseSettings);
/**
 * Service Settings for payment pre-authorization (tabs)
 *
 * SOURCE PreAuthSettings @ squareup/rstonboard/service_settings/service_settings.proto at 128:1
 */
export const PreAuthSettings = $root.lookupType('squareup.rstonboard.PreAuthSettings');
fixType(PreAuthSettings);
Builder.createAndAttachToType(PreAuthSettings);
/**
 * Service Settings regarding reservations
 *
 * SOURCE ReservationSettings @ squareup/rstonboard/service_settings/service_settings.proto at 134:1
 */
export const ReservationSettings = $root.lookupType('squareup.rstonboard.ReservationSettings');
fixType(ReservationSettings);
Builder.createAndAttachToType(ReservationSettings);
/**
 * Controls the Food & Beverage First Table Touch Service Setting.
 * Design: https://docs.google.com/document/d/1Z512Jg6YvgWpknWbi_Uopn6-_nqH8cXJK9wyPMbSMbc/edit
 *
 * SOURCE FirstTableTouch @ squareup/rstonboard/service_settings/service_settings.proto at 137:3
 */
ReservationSettings.FirstTableTouch = $root.lookupEnum('squareup.rstonboard.ReservationSettings.FirstTableTouch').values;
/**
 * Top-level container for all Food & Beverage Service Settings.
 * Each field represents a category of related settings that can be independently configured.
 *
 * SOURCE ServiceSettings @ squareup/rstonboard/service_settings/service_settings.proto at 153:1
 */
export const ServiceSettings = $root.lookupType('squareup.rstonboard.ServiceSettings');
fixType(ServiceSettings);
Builder.createAndAttachToType(ServiceSettings);